import { useState } from 'react';
import { useFormContext } from 'react-hook-form';

const useTextInputLogic = ({
  defaultPlaceholder,
  handleBlur,
  handleChange,
  handleFocus,
  icon,
  id,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [placeholder, setPlaceholder] = useState(defaultPlaceholder);
  const {
    onBlur: registerOnBlur,
    onChange: registerOnChange,
    ...register
  } = useFormContext().register(id);
  const hasIcon = !!icon;

  const onBlur = event => {
    setIsFocused(false);
    setPlaceholder(defaultPlaceholder); // was removed in onFocus, add it back now
    registerOnBlur(event);
    if (handleBlur) handleBlur(event);
  };

  const onChange = event => {
    registerOnChange(event);
    if (handleChange) handleChange(event);
  };

  const onFocus = event => {
    setIsFocused(true);
    setPlaceholder('');
    if (handleFocus) handleFocus(event);
  };

  return {
    hasIcon,
    isFocused,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    register,
  };
};

export default useTextInputLogic;
